import { render, staticRenderFns } from "./xhdpage.vue?vue&type=template&id=1a15bb52&scoped=true&"
import script from "./xhdpage.vue?vue&type=script&lang=js&"
export * from "./xhdpage.vue?vue&type=script&lang=js&"
import style0 from "./xhdpage.vue?vue&type=style&index=0&id=1a15bb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15bb52",
  null
  
)

export default component.exports